import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Input, InputSignal, OnDestroy, Output } from '@angular/core';

import { SwiperOptions             } from 'swiper/types';
import { register, SwiperContainer } from 'swiper/element/bundle';
register();

import Hammer from 'hammerjs';

@Directive({
  selector: '[swiper]',
  standalone: false
})
export class SwiperDirective implements AfterViewInit, OnDestroy {
  @Input()  config?: InputSignal<SwiperOptions>;
  @Output() swipeLeft  = new EventEmitter<void>();
  @Output() swipeRight = new EventEmitter<void>();

  private resizeObserver!: ResizeObserver;
  private elementRef:      ElementRef<SwiperContainer> = inject<ElementRef<SwiperContainer>>(ElementRef<SwiperContainer>);
  private hammer?:         HammerManager;

  constructor(private el: ElementRef) {
    this.elementRef.nativeElement.setAttribute('mousewheel', 'true');
  }

  public ngAfterViewInit(): void {
    if (this.config) {
      this.prepareSwiperOptions();
      this.prepareHammer();
      this.startSlidesPerViewResizer();
    }
  }

  private prepareSwiperOptions(): void {
    Object.assign(this.elementRef.nativeElement, {
      ...this.config,
      observer: true,
      observeParents: true,
    });

    this.elementRef.nativeElement.initialize();
  }

  private prepareHammer(): void {
    this.hammer = new Hammer(this.el.nativeElement);
    this.hammer.on('swipeleft',  () => this.swipeLeft.emit());
    this.hammer.on('swiperight', () => this.swipeRight.emit());
  }

  private startSlidesPerViewResizer(): void {    
    this.resizeObserver = new ResizeObserver(entries => {
      let width         = entries[0].contentRect.width;
      let slidesPerView = Math.max(Math.floor(width/425), 1);
      Object.assign(this.elementRef.nativeElement, { slidesPerView });
      this.elementRef.nativeElement.swiper.update();
    });

    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.hammer?.destroy();
    this.resizeObserver?.disconnect();
  }

}
